import { DATA_SELECTOR_ID } from "../utils/context-layer-variables";
export function showNotificationSuccessPopup(contextLayerContainer, template) {
  let div = document.createElement('div');
  div.innerHTML = template.trim();
  contextLayerContainer === null || contextLayerContainer === void 0 ? void 0 : contextLayerContainer.insertAdjacentElement('afterbegin', div.firstElementChild);
  const notificationSelector = contextLayerContainer === null || contextLayerContainer === void 0 ? void 0 : contextLayerContainer.querySelector(`[${DATA_SELECTOR_ID}="context-notification-success"]`);
  if (notificationSelector) {
    const closeButton = notificationSelector.querySelector('.js-notification-success__button-close');
    closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', () => {
      showAutoContextToast(notificationSelector, false);
    });
    showAutoContextToast(notificationSelector, true);
    setTimeout(() => {
      showAutoContextToast(notificationSelector, false);
    }, 5000);
  }
}
function showAutoContextToast(notificationSelector, toShow) {
  notificationSelector.classList.add(toShow ? 'show' : 'hide');
  notificationSelector.classList.remove(toShow ? 'hide' : 'show');
}